// src/pages/admin/components/AssignmentManagement/AssignmentDetails.js
import React, { useState, useCallback } from 'react';

const AssignmentDetails = ({
  selectedAssignment,
  formTitle,
  setFormTitle,
  formInstructions,
  setFormInstructions,
  onSave,
  onDelete,
  onToggleEditing,
  isEditing,
  loading
}) => {
  const [instructionsError, setInstructionsError] = useState(false);

  const handleInstructionsChange = useCallback((e) => {
    const content = e.target.value;
    setFormInstructions(content);
    setInstructionsError(content === '');
  }, [setFormInstructions]);

  if (!selectedAssignment) {
    return (
      <div className="assignment-details empty-state">
        <div className="empty-content">
          <h3>No Assignment Selected</h3>
          <p>Select an assignment from the list or create a new one.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="assignment-details">
      <div className="details-header">
        <h3>Assignment Details</h3>
        <div className="details-actions">
          <button
            className="btn-primary"
            onClick={onToggleEditing}
            disabled={loading}
          >
            {isEditing ? 'Cancel' : 'Edit'}
          </button>

          {isEditing && (
            <button
              className="btn-primary"
              onClick={onSave}
              disabled={loading}
              style={{ backgroundColor: '#28a745' }}
            >
              {loading ? 'Saving...' : 'Save'}
            </button>
          )}

          <button
            className="btn-danger"
            onClick={onDelete}
            disabled={loading}
          >
            Delete
          </button>
        </div>
      </div>

      <div className="details-content">
        <div className="form-group">
          <label htmlFor="assignment-title">Title</label>
          <input
            type="text"
            id="assignment-title"
            value={formTitle}
            onChange={(e) => setFormTitle(e.target.value)}
            required
            disabled={!isEditing}
          />
        </div>

        <div className="form-group">
          <label htmlFor="assignment-instructions">Instructions</label>
          <div style={{ border: instructionsError ? '1px solid #ff4747' : '1px solid #ddd', borderRadius: '4px' }}>
            <textarea
              id="assignment-instructions"
              value={formInstructions}
              onChange={handleInstructionsChange}
              disabled={!isEditing}
              placeholder="Enter assignment instructions here..."
            />
          </div>
          {instructionsError && (
            <div className="field-error">Instructions are required</div>
          )}
          {formInstructions && (
            <div className="instruction-preview">
              <h4>Preview:</h4>
              <div style={{ whiteSpace: 'pre-wrap' }}>{formInstructions}</div>
            </div>
          )}
        </div>

        {isEditing && (
          <div className="form-actions">
            <button
              className="btn-primary"
              onClick={onSave}
              disabled={loading || instructionsError}
            >
              {loading ? 'Saving...' : 'Save Changes'}
            </button>
            <button
              className="btn-danger"
              onClick={onDelete}
              disabled={loading}
            >
              Delete Assignment
            </button>
          </div>
        )}

        <div className="form-hint">
          <p>Dates, status, and target groups are managed in the Groups tab.</p>
        </div>
      </div>
    </div>
  );
};

export default React.memo(AssignmentDetails);